import Utilities from '../utilities/utilities';

export default class websiteMessageAdditional {
	/**
	 * @param {Object} options - User options
	 */
	constructor(options) {


		window.addEventListener('DOMContentLoaded', () => {
			this.init();
		});

		window.addEventListener('NAVIGATE_IN', () => {
			this.init();
		});

		window.addEventListener('infiniteScrollAppended', () => {
			this.init();
		});
	}

	init() {

		var elNameAdditional = '.js-website-message-additional';
        var elCloseAdditional = '.js-website-message-close-additional';

        var $elAdditional = jQuery(elNameAdditional);
        
        if ($elAdditional.length == 0) {
			return;
		}

		if (Utilities.getCookie('cookie-website-message-additional')) {
			jQuery(elNameAdditional).remove();
		}

		jQuery(elCloseAdditional).on("click", function(e){

			if (jQuery(elCloseAdditional).hasClass('js-website-message-set-cookie-additional')) {
				const cookieCalcHour = 1/8;
				Utilities.setCookie('cookie-website-message-additional', 'active', cookieCalcHour);
			}

			jQuery(elNameAdditional).remove();

		});


    }
}